module.exports = __webpack_public_path__ + "static/img/footerlogo.4f0c1bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/footerlogo.png
// module id = ksn0
// module chunks = 18